import { FC } from 'react';
import { TSelfEnrollmentProgress } from '@api/io/session.io';
import { useIntl } from 'react-intl';
import { publishAnalyticsEvent } from '@utils/publishAnalyticsEvent';

type ContinueButtonProps = {
  progress?: TSelfEnrollmentProgress | null;
  link: string;
  /** Overrides the progress based label, e.g. for project selections where "Start course" makes no sense. */
  labelId?: string;
};

const progressMap: Record<
  TSelfEnrollmentProgress,
  {
    key: string;
  }
> = {
  incomplete: {
    key: 'catalog.course.action.continue',
  },
  notAttempted: {
    key: 'catalog.course.action.start',
  },
  completed: {
    key: 'catalog.course.action.complete',
  },
  unknown: {
    key: 'catalog.course.action.start',
  },
};

export const ContinueButton: FC<ContinueButtonProps> = ({
  progress,
  link,
  labelId,
}) => {
  const intl = useIntl();

  if (!progress) {
    return null;
  }

  const progressDetails = progressMap[progress];

  const handleProgressClick = () => {
    publishAnalyticsEvent(
      { context: 'CourseDetailsPage', action: 'ProgressCourseClicked' },
      { link, progress },
    );
  };

  return (
    <a
      href={link}
      className="lf:l-btn lf:l-btn-md lf:l-btn-primary"
      onClick={handleProgressClick}
    >
      {intl.formatMessage({ id: labelId ?? progressDetails.key })}
    </a>
  );
};
